import { Component, OnInit, ViewChild, EventEmitter, NgModule, CUSTOM_ELEMENTS_SCHEMA, Inject, Output, Input } from '@angular/core';
import { FormGroup, FormControl, FormArray, Validators, FormBuilder, ReactiveFormsModule, NgControl } from '@angular/forms';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatTabsModule, MatTabChangeEvent, MatDialogRef,
  MatTooltipModule, MatRadioModule, MatPaginator, MatSort, MatSlideToggleModule} from '@angular/material';
import { DataTableModule, SharedModule } from 'primeng/primeng';
import { MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { User } from '../../users/user.model';
import { Audit } from '../../audits/audit.model';
import { UserService } from '../../users/user.service';
import { AuditService } from '../../audits/audit.service';
import { UserProfileService } from '../../userprofile/userprofile.service';
import { UserProfile } from '../../userprofile/userprofile.model';
import { UserEditComponent } from '../../users/user-edit/user-edit.component';
import { CalendarService } from './../calendar.service';
import { Calendar } from './../calendar.model';
import { CalendarEventTypeService } from '../calendar-event-type.service';
import { CalendarEventType } from '../calendar-event-type.model';
import * as moment from 'moment-timezone';

@Component({
    selector: 'app-calendar-add',
    templateUrl: './calendar-add.component.html',
    styleUrls: ['./calendar-add.component.css']
})
export class CalendarAddComponent implements OnInit {
    private isAuthenticatedSubscription: any;
    public eventTypes: CalendarEventType[];
    public calendar_error: string;
    public isAdmin = true;
    public dateRows: any;
    public date_error: string;
    public isFail: boolean = false;
    public startTimes: any[] = [
        { name: 'All Day', value: 0},
        { name: '8:00AM', value: 8},
        { name: '9:00AM', value: 9},
        { name: '10:00AM', value: 10},
        { name: '11:00AM', value: 11},
        { name: '12:00PM (Noon)', value: 12 },
        { name: '1:00PM', value: 13 },
        { name: '2:00PM', value: 14 },
        { name: '3:00PM', value: 15 },
        { name: '4:00PM', value: 16 },
        { name: '5:00PM', value: 17 },
        { name: '6:00PM', value: 18 },
        { name: '7:00PM', value: 19 },
        { name: '8:00PM', value: 20 },
    ];
    public calendarForm: FormGroup;
    public descriptionControl: FormControl = new FormControl();
    public dateControl: FormControl = new FormControl();
    public dayTypeControl: FormControl = new FormControl();
    public timesControl: FormControl = new FormControl();
    private pageNumber: number;
    private pageSize: number;
    @ViewChild(MatPaginator) calendarPaginator: MatPaginator;

    constructor(
        public dialogRef: MatDialogRef<CalendarAddComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        public calendarAddDialog: MatDialog,
        private eventService: CalendarEventTypeService,
        private calendarService: CalendarService) {
        this.createForm();
        this.pageNumber = data.pageNumber;
        this.pageSize = data.pageSize;
    }
   
    ngOnInit() {
        this.getEvents();
    }

    createForm() {
      this.calendarForm = new FormGroup({
          dateRows: this.fb.array([this.initDateRows()])
        });
  }

  getEvents() {
      this.eventService.getCalendarEventTypeCache()
          .then(resp => {
              this.eventTypes = resp;
          })
  }

  initDateRows() {
      return this.fb.group({
          date: [null, Validators.required],
          description: [null, Validators.required],
          time: [null],
          eventTypeId: [null, Validators.required]
      });
  }

  addNewDate() {
      const control = <FormArray>this.calendarForm.controls['dateRows'];
      control.push(this.initDateRows());
  }

  deleteNewDate(index: number) {
    const control = <FormArray>this.calendarForm.controls['dateRows'];
    control.removeAt(index);
  }

  onSubmit() {
      let calendar_error = null;

      if (!this.calendarForm.valid)
          return;

      let calendarEvents: Calendar[];
      calendarEvents = this.calendarForm.value.dateRows;

      for (let calEvent of calendarEvents) {
          // force date to be est timezone
          var estDateTime: Date = new Date(moment.tz(calEvent.date, 'America/New_York').format());
          estDateTime.setHours(parseInt(calEvent.time));
          calEvent.date = estDateTime;
      }

      this.calendarService.addCalendarEvent(calendarEvents)
          .then((result) => {
              this.calendarService.getCalendarEvents(this.pageNumber, this.pageSize, false);
              this.dialogRef.close(result);
          })
          .catch(error => {
              console.log(error);
              this.date_error = "This date already exists in the Team Calendar";  
              this.isFail = true;
          })

      if (this.calendarForm.value.dateRows.find(x => x.id === calendarEvents) === undefined) {
          this.calendar_error = this.calendarForm.value.dateRows + ' already exists. Cannot add. Please try again. ';
      };     
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/calendar/calendar-add/calendar-add.component.ts